export const LIST_PRODUCT_TYPES_SUCCESS = 'LIST_PRODUCT_TYPES_SUCCESS';
export const LIST_PRODUCT_TYPES_FAILURE = 'LIST_PRODUCT_TYPES_FAILURE';

export const CREATE_PRODUCT_TYPE_SUCCESS = 'CREATE_PRODUCT_TYPE_SUCCESS';
export const CREATE_PRODUCT_TYPE_FAILURE = 'CREATE_PRODUCT_TYPE_FAILURE';

export const EDIT_PRODUCT_TYPE_SUCCESS = 'EDIT_PRODUCT_TYPE_SUCCESS';
export const EDIT_PRODUCT_TYPE_FAILURE = 'EDIT_PRODUCT_TYPE_FAILURE';

export const UPDATE_PRODUCT_TYPE_SUCCESS = 'UPDATE_PRODUCT_TYPE_SUCCESS';
export const UPDATE_PRODUCT_TYPE_FAILURE = 'UPDATE_PRODUCT_TYPE_FAILURE';

export const DELETE_PRODUCT_TYPE_SUCCESS = 'DELETE_PRODUCT_TYPE_SUCCESS';
export const DELETE_PRODUCT_TYPE_FAILURE = 'DELETE_PRODUCT_TYPE_FAILURE';

export const NEW_PRODUCT_TYPE_SUCCESS = 'NEW_PRODUCT_TYPE_SUCCESS';
export const NEW_PRODUCT_TYPE_FAILURE = 'NEW_PRODUCT_TYPE_FAILURE';
